import styles from './VerticalCollage.module.scss';

const VerticalCollage = ({ image }) => (
  <div className={styles.column}>
    <div className={styles.track}>
      <img src={image} alt="" />
      <img src={image} alt="" />
    </div>
  </div>
);

export default VerticalCollage;
